import {faCircle} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

type Props = {
  value: number;
};

function GpmCell({value}: Props) {
  let color;

  if (value >= 1500) {
    color = 'text-blue-500';
  } else if (value <= 1499 && value >= 1000) {
    color = 'text-green-500';
  } else if (value <= 999 && value >= 500) {
    color = 'text-orange-500';
  } else {
    color = 'text-red-500';
  }

  return (
    <LabelContainer>
      <StatusIndicator icon={faCircle} color={color} />
      <span className="ml-1 font-bold text-xs text-gray-700">{value}</span>
    </LabelContainer>
  );
}

const StatusIndicator = styled(FontAwesomeIcon).attrs<{color: string}>(({color}) => ({
  className: 'text-xs ' + color,
}))<{color: string}>``;

const LabelContainer = styled.div.attrs({
  className: 'text-gray-800 text-base flex items-center',
})``;

export default GpmCell;
